module.exports = __webpack_public_path__ + "img/menuCamera.dd8682fb.svg";